import { Component, Input, OnInit } from '@angular/core';
import { ClipboardService } from 'ngx-clipboard';
import { BrandLogo } from 'src/app/data-models/device/brand-logo.model';
import { MyDevice } from 'src/app/data-models/device/my-device.model';
import { DeviceService } from 'src/app/services/device/device.service';

@Component({
	selector: 'vtr-widget-about-my-device',
	templateUrl: './widget-about-my-device.component.html',
	styleUrls: ['./widget-about-my-device.component.scss'],
})
export class WidgetAboutMyDeviceComponent implements OnInit {
	public myDevice: MyDevice;
	public brandLogo: BrandLogo = new BrandLogo();

	brandLogos: BrandLogo[] = [
		{ logoType: 'lenovo', logoPath: 'assets/images/dashboard/lenovo_logo.jpg' },
		{ logoType: 'think', logoPath: 'assets/images/dashboard/think_logo.svg' },
	];

	constructor(public deviceService: DeviceService, private clipboardService: ClipboardService) {
		this.myDevice = new MyDevice();
		this.updateLogo('lenovo');
	}
	ngOnInit(): void {
		this.getDeviceInfo();
	}

	private getDeviceInfo() {
		// machineinfo
		this.deviceService.getMachineInfo().then((machineInfo) => {
			this.myDevice.family = machineInfo.family;
			this.myDevice.sn = machineInfo.serialnumber;
			this.myDevice.bios = machineInfo.biosVersion;
			this.myDevice.subBrand = machineInfo.subBrand;
			this.myDevice.productNo = machineInfo.mtm;
			this.updateLogo(this.getLogoType(machineInfo));
		});
	}

	getLogoType(machineInfo) {
		let logoType = undefined;

		//special case
		if (machineInfo.family && machineInfo.family.toLowerCase().includes('lenovo k14')) {
			logoType = 'lenovo';
		}

		//special case hit
		if (logoType) return logoType;

		//normal case
		if (machineInfo.brand && machineInfo.brand.toLowerCase().includes('think')) {
			logoType = 'think';
		} else {
			logoType = 'lenovo';
		}

		return logoType;
	}

	updateLogo(logoType) {
		let logo = this.brandLogos.find((logo) => logo.logoType === logoType);
		if (logo) {
			this.brandLogo.logoType = logo.logoType;
			this.brandLogo.logoPath = logo.logoPath;
		}
	}

	copy(text: string, element: any) {
		this.clipboardService.copyFromContent(text);
		element.focus();
	}
}
